import axios from 'axios';

const token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.log('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

const axiosInstance = axios.create({
    baseURL: '',
    timeout: 60000,
    responseType: 'json',
    headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    },
});

export default axiosInstance;
